// Counts the billable Google Maps Platform calls the checkout makes, so the cost
// of an address entry can be measured rather than inferred from the invoice a
// month later.
//
// Each Google SKU is billed per request, and the free allowance is per SKU per
// month (10k), so what matters is calls-per-address-entry, not calls-per-day.
// One `gmaps_usage` event is emitted per address-modal session (on close), which
// makes the before/after of a change visible in PostHog the same day.
//
// Fire-and-forget: every path is wrapped, and a failure here must never affect
// an address entry.

const counts = {};

/** Record one billable call. `sku` is our own label, not Google's SKU id. */
export function meter(sku) {
  try {
    counts[sku] = (counts[sku] || 0) + 1;
  } catch (e) { /* noop */ }
}

/**
 * Emit the tally for this address-entry session and reset it.
 * `reason` distinguishes a saved address from an abandoned one — an abandoned
 * entry still costs money, and is exactly the waste worth watching.
 */
export function flushMeter(reason) {
  try {
    const keys = Object.keys(counts);
    if (!keys.length) return;
    const props = { reason: reason || 'unknown', total: 0 };
    keys.forEach((k) => { props[k] = counts[k]; props.total += counts[k]; delete counts[k]; });
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('gmaps_usage', props);
    }
  } catch (e) { /* noop */ }
}
